var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import createFeed from '../../requests/feed/createFeed';
/**
 *
 */
var CreateFeedCommand = /** @class */ (function (_super) {
    __extends(CreateFeedCommand, _super);
    function CreateFeedCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param feed Feed
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    CreateFeedCommand.prototype.execute = function (feed, organisationId, intl) {
        this.intl = intl;
        var promise = createFeed(feed, organisationId);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    CreateFeedCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.feed.added' }), 'dark', true);
    };
    return CreateFeedCommand;
}(Command));
export default CreateFeedCommand;
